<template>
  <div id="ListingContainer" :class="computedClass">
    <NoResultsInfo/>
    <ProductCard v-for="product in getProducts" :product="product" :key="product.id" :component="hasCustomComponent"/>
  </div>
</template>


<script setup lang="ts">
import {inject, computed, ref} from 'vue';
import {storeToRefs} from "pinia";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import ProductCard from './ProductCards/ProductCard.vue'

import {SmartSearchConfigInterface} from '@/core/types'
import NoResultsInfo from "@/components/SerpPage/ResultsInfoWrapper/NoResultsInfo.vue";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!)
const customComponents = SmartSearchConfig.value.serp.customComponents
const {smallDevice, mediumDevice, largeDevice, extraLargeDevice} = SmartSearchConfig.value.serp.gridSettings.column

const computedClass = computed(() => {
  return [
    `q-row-cols-xl-${extraLargeDevice}`,
    `q-row-cols-lg-${largeDevice}`,
    `q-row-cols-md-${mediumDevice}`,
    `q-row-cols-${smallDevice}`,
    'q-row',
    'q-m-1'
  ];
});

const ComponentName = 'productCard'
// eslint-disable-next-line no-prototype-builtins
const hasCustomComponent = customComponents.hasOwnProperty(ComponentName) ? customComponents[ComponentName] : null;
const serpStore = useSerpResultsStore();
const {getProducts} = storeToRefs(serpStore)


</script>
